require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./product-swai-pangasius.json") })
        }
      }, "path---product-swai-pangasius");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---product-swai-pangasius!./.cache/json/product-swai-pangasius.json
// module id = 529
// module chunks = 231608221292675